import { Box, Grid, makeStyles, Typography } from '@material-ui/core';
import PaymentIcon from '@material-ui/icons/Payment';
import React, { useContext } from 'react';
import { FormRadioNoFormOption } from 'src/lib/templates/components/FormRadioNoForm';
import { Order } from 'src/app/models/business/Order';
import { loading } from '../../../../../assets/images';
import { grey, primary } from '../../../../../theme/colors';
import { OrderDetailContext } from '../../context';

const styles = makeStyles(() => ({
  container: {
    paddingTop: 15,
    boxSizing: 'border-box',
  },
  iconColor: { color: primary.paleBlueStrong },
  iconColorDisabled: { color: grey.textSecondary },
  inputContainer: {
    display: 'flex',
    marginBottom: 10,
  },
  title: {
    marginBottom: 10,
    fontSize: 16,
    lineHeight: '17px',
    fontWeight: 400,
  },
}));

interface PaymentIDInputProps {
  dataOrder: Order;
  gatewayId: string | null;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>, value: string) => void;
  operationOrderGateway: FormRadioNoFormOption[];
}

export const PaymentIDInput = ({
  dataOrder,
  gatewayId,
  handleChange,
  operationOrderGateway,
}: PaymentIDInputProps) => {
  const classes = styles();
  const { loadingPaymentIdInputs } = useContext(OrderDetailContext);

  if (loadingPaymentIdInputs)
    return (
      <div className={classes.container}>
        <Grid container justify="center" alignItems="center">
          <img src={loading} width={50} alt="loading" />
        </Grid>
      </div>
    );
  return (
    <div className={classes.container}>
      <Box>
        <Typography variant="h5" className={classes.title}>
          Medio de pago:
        </Typography>
        <Box display="flex" alignItems="center" mb={2} ml={1}>
          <PaymentIcon color="primary" style={{ marginRight: 8 }} />
          <Typography>
            {operationOrderGateway.find((gateway) => gateway.id === gatewayId)?.name ||
              dataOrder.payment.reference ||
              'Sin tarjeta'}
          </Typography>
        </Box>
      </Box>
    </div>
  );
};
